class FoxSellCart {
  constructor(container) {
    this.container = container;
    this.addToCartButton = container.querySelector('.foxsell-add-to-cart-btn');
    this.addToCartWrapper = container.querySelector('.foxsell-dropdown-add-to-cart-button');
    this.dropdowns = container.querySelectorAll('.foxsell-dropdown');
    this.buttonTexts = {
      default: this.addToCartWrapper.dataset.addToCartText || 'Add to Cart',
      confirmation: this.addToCartWrapper.dataset.addToCartConfirmationText || 'Added to Cart',
      loading: 'Adding...',
      error: 'Error - Try Again'
    };
    this.init();
    this.updateButtonState(); // Initial state check
  }

  updateButtonState() {
    if (!this.addToCartButton) return;

    const allDropdownsSelected = Array.from(this.dropdowns).every(dropdown => 
      dropdown.dataset.selectedVariantId && dropdown.dataset.selectedVariantId !== ''
    );

    this.addToCartButton.disabled = !allDropdownsSelected;
    this.addToCartButton.classList.toggle('disabled', !allDropdownsSelected);
  }

  async addToCart() {
    const date = Date.now();
    const bundleId = `${this.container.dataset.bundleId}_${date}`;
    const bundleVariantId = this.container.dataset.variantId;

    const selectedItems = [];
    // const properties = {};
    // Collect all selected variants
    this.dropdowns.forEach(dropdown => {
      const variantId = dropdown.dataset.selectedVariantId;
      const category = dropdown.dataset.category;
      const categoryQuantity = parseInt(dropdown.dataset.categoryQuantity || 1);
      if (variantId) {
        selectedItems.push({
          variantId: variantId,
          category: category,
          quantity: categoryQuantity,
          type: 'product'
        });

        // const productTitle = dropdown.dataset.selectedTitle;
        // properties[productTitle] = (properties[productTitle] || 0) + categoryQuantity;
      }
    });

    const items = [
      {
        id: bundleVariantId,
        quantity: 1,
        properties: {
          "__foxsell:dynamic_add_on_bundle_id": bundleId,
          "__foxsell:dynamic_add_on_bundle_items": JSON.stringify(selectedItems),
          // ...Object.fromEntries(
          //   Object.entries(properties).map(([key, value]) => [key, `x${value}`])
          // )
        }
      }
    ];

    // Don't proceed if no items selected
    if (selectedItems.length < this.dropdowns.length) {
      return;
    }

    // Let the free-gift system know this bundle's real price so it can detect
    // threshold crossings on this same add, instead of only catching up afterwards.
    const bundlePriceEl = this.container.querySelector('.foxsell-bundle-price');
    if (bundlePriceEl && bundlePriceEl.dataset.priceStrategy === 'fixed_pricing') {
      const priceCents = parseInt(bundlePriceEl.dataset.priceValue, 10);
      if (priceCents > 0) {
        window.__DOGSUPPY_VARIANT_PRICE_MAP__ = window.__DOGSUPPY_VARIANT_PRICE_MAP__ || {};
        window.__DOGSUPPY_VARIANT_PRICE_MAP__[String(bundleVariantId)] = priceCents;
      }
    }

    try {
      // Disable button and show loading state
      this.addToCartButton.disabled = true;
      this.addToCartButton.setAttribute('data-foxsell-atc-loading', 'true');
      this.addToCartButton.textContent = '';

      const cartItemsComponents = document.querySelectorAll('cart-items-component');
      const cartSectionIds = Array.from(cartItemsComponents)
        .map((item) => item instanceof HTMLElement ? item.dataset.sectionId : '')
        .filter(Boolean);

      // Add items to cart
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          items: items,
          sections: cartSectionIds.join(','),
          sections_url: window.location.pathname
        })
      });

      if (!response.ok) {
        throw new Error('Failed to add items to cart');
      }

      const responseData = await response.json();
      document.dispatchEvent(
        new CustomEvent('cart:update', {
          bubbles: true,
          detail: {
            resource: responseData,
            sourceId: bundleVariantId,
            data: {
              source: 'product-form-component',
              itemCount: 1,
              variantId: bundleVariantId,
              sections: responseData.sections || {},
            },
          },
        })
      );

      // Show success state
      this.addToCartButton.removeAttribute('data-foxsell-atc-loading');
      this.addToCartButton.textContent = this.buttonTexts.confirmation;
      // this.onAddToCartSuccess(response);
      setTimeout(() => {
        this.addToCartButton.textContent = this.buttonTexts.default;
        this.addToCartButton.disabled = false;
        this.updateButtonState(); // Recheck state after reset
      }, 2000);

    } catch (error) {
      console.error('Error adding to cart:', error);
      this.addToCartButton.removeAttribute('data-foxsell-atc-loading');
      this.addToCartButton.textContent = this.buttonTexts.error;
      setTimeout(() => {
        this.addToCartButton.textContent = this.buttonTexts.default;
        this.addToCartButton.disabled = false;
        this.updateButtonState(); // Recheck state after reset
      }, 2000);
    }
  }

  async onAddToCartSuccess(response) {
    const responseData = await response.json()
    const cart = document.querySelector('cart-drawer');
    if (cart) {
        try {
        cart.renderContents(responseData);
        cart.open();
        if (cart && cart.classList.contains('is-empty')) {
            cart.classList.remove('is-empty');
        }
        } catch (e) {
        window.location.href = window?.routes?.cart_url || '/cart'
        }
    } else {
        window.location.href = window?.routes?.cart_url || '/cart'  
    }
  }

  init() {
    if (this.addToCartButton) {
      this.addToCartButton.addEventListener('click', () => this.addToCart());
    }

    // Listen for custom event when variants are selected
    this.container.addEventListener('variant:selected', () => {
      this.updateButtonState();
    });
  }
}

class FoxSellDropdown {
  constructor(container) {
    this.container = container;
    this.header = container.querySelector('.foxsell-dropdown__header');
    this.searchInput = container.querySelector('.foxsell-dropdown__search-input');
    this.filters = container.querySelectorAll('.foxsell-dropdown__filter');
    this.items = container.querySelectorAll('.foxsell-dropdown__item');
    this.selectedImage = container.querySelector('.foxsell-dropdown__selected-image img');
    this.selectedTitle = container.querySelector('.foxsell-dropdown__selected-title');
    this.selectedType = container.querySelector('.foxsell-dropdown__selected-type');
    
    this.currencyConversionRate = parseFloat(window.Shopify?.currency?.rate || 1);
    this.currencyFormat = this.container.closest('.foxsell-dropdown-container').dataset.currencyFormat;
    this.bundlePriceElement = this.container.closest('.foxsell-dropdown-container').querySelector('.foxsell-bundle-price');
    
    this.init();
  }

  updateBundlePrice() {
    const container = this.container.closest('.foxsell-dropdown-container');
    const dropdowns = container.querySelectorAll('.foxsell-dropdown');
    const priceStrategy = this.bundlePriceElement.dataset.priceStrategy;
    const discountPercentage = parseFloat(this.bundlePriceElement.dataset.priceValue) || 0;

    if (priceStrategy === 'dynamic_pricing') {
      let totalPrice = 0;
      dropdowns.forEach(dropdown => {
        const variantPrice = parseFloat(dropdown.dataset.selectedVariantPrice) || 0;
        totalPrice += variantPrice;
      });

      // Clear existing content
      this.bundlePriceElement.innerHTML = '';

      if (discountPercentage > 0) {
        // Calculate and show discounted price first
        const discountedPrice = totalPrice * (1 - discountPercentage / 100);
        const finalPriceSpan = document.createElement('span');
        finalPriceSpan.className = 'final-price';
        finalPriceSpan.textContent = this.formatMoney(discountedPrice * 100 * this.currencyConversionRate);
        this.bundlePriceElement.appendChild(finalPriceSpan);

        // Show original price with strikethrough
        const originalPriceSpan = document.createElement('span');
        originalPriceSpan.className = 'original-price';
        originalPriceSpan.textContent = this.formatMoney(totalPrice * 100 * this.currencyConversionRate);
        this.bundlePriceElement.appendChild(originalPriceSpan);

        // Show discount badge last
        const discountBadge = document.createElement('div');
        discountBadge.className = 'discount-badge';
        discountBadge.textContent = `${discountPercentage}% OFF`;
        this.bundlePriceElement.appendChild(discountBadge);
      } else {
        // Show only the total price
        this.bundlePriceElement.textContent = this.formatMoney(totalPrice * 100 * this.currencyConversionRate);
      }
    }
  }

  formatMoney(amount) {
    if (typeof amount == 'string') { amount = amount.replace('.', ''); }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = this.currencyFormat;

    function defaultOption(opt, def) {
        return (typeof opt == 'undefined' ? def : opt);
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
        precision = defaultOption(precision, 2);
        thousands = defaultOption(thousands, ',');
        decimal = defaultOption(decimal, '.');

        if (isNaN(number) || number == null) { return 0; }

        number = (number / 100.0).toFixed(precision);

        var parts = number.split('.'),
            dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
            amount = parts[1] ? (decimal + parts[1]) : '';

        return dollars + amount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
        case 'amount':
            value = formatWithDelimiters(amount, 2);
            break;
        case 'amount_no_decimals':
            value = formatWithDelimiters(amount, 0);
            break;
        case 'amount_with_comma_separator':
            value = formatWithDelimiters(amount, 2, '.', ',');
            break;
        case 'amount_no_decimals_with_comma_separator':
            value = formatWithDelimiters(amount, 0, '.', ',');
            break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  init() {
    // Toggle dropdown
    this.header.addEventListener('click', () => {
      if(this.items.length < 2) return

      this.container.classList.toggle('active');
    });

    // Search functionality
    if (this.searchInput) {
      this.searchInput.addEventListener('input', (e) => {
        const searchTerm = e.target.value.toLowerCase();
        this.items.forEach(item => {
          const title = item.querySelector('.foxsell-dropdown__item-title').textContent.toLowerCase();
          const shouldShow = title.includes(searchTerm);
          item.style.display = shouldShow ? 'flex' : 'none';
        });
      });
    }

    // Filter functionality
    this.filters.forEach(filter => {
      filter.addEventListener('click', () => {
        // Update active state
        this.filters.forEach(f => f.classList.remove('active'));
        filter.classList.add('active');

        // Filter items
        const filterType = filter.dataset.filter;
        this.items.forEach(item => {
          if (filterType === 'all') {
            item.style.display = 'flex';
          } else {
            const itemType = item.dataset.type;
            item.style.display = itemType === filterType ? 'flex' : 'none';
          }
        });
      });
    });

    // Item selection
    this.items.forEach(item => {
      item.addEventListener('click', () => {
        // Skip if item is unavailable
        if (item.classList.contains('foxsell-dropdown__unavailable')) {
          return;
        }

        const title = item.dataset.title;
        const gender = item.dataset.gender;
        const image = item.querySelector('.foxsell-dropdown__item-image img').src;
        const variantId = item.dataset.variantId;
        const variantPrice = item.dataset.variantPrice;
        
        // Update selected display
        this.selectedImage.src = image;
        this.selectedTitle.textContent = title;
        if (this.selectedType) {
          this.selectedType.textContent = gender;
        }
        
        // Store variant ID, price and title in the main dropdown element
        this.container.dataset.selectedVariantId = variantId;
        this.container.dataset.selectedVariantPrice = variantPrice;
        this.container.dataset.selectedTitle = title;
        
        // Update bundle price
        this.updateBundlePrice();
        
        // Close dropdown
        this.container.classList.remove('active');

        // Dispatch event for cart button state update
        this.container.closest('.foxsell-dropdown-container').dispatchEvent(new Event('variant:selected'));
      });
    });

    if(this.items.length === 1){
      this.items[0].click()
      this.header.style.cursor = 'auto';
      const dropdownIcon = this.container.querySelector('.foxsell-dropdown__icon');
      if(dropdownIcon){
        dropdownIcon.style.display = 'none';
      }
    }

    // Close dropdown when clicking outside
    document.addEventListener('click', (e) => {
      if (!this.container.contains(e.target)) {
        this.container.classList.remove('active');
      }
    });
  }
}

// Initialize all foxsell dropdowns and cart on the page
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.foxsell-dropdown').forEach(dropdown => new FoxSellDropdown(dropdown));
  document.querySelectorAll('.foxsell-dropdown-container').forEach(container => new FoxSellCart(container));
});
